export const common = {
  nav: {
    home: 'Home',
    about: 'About',
    rooms: 'Rooms & Space',
    gallery: 'Gallery',
    reservation: 'Book Now',
    access: 'Access',
    contact: 'Contact',
    forOwners: 'For Property Owners',
    freeConsultation: 'Free Consultation',
  },
  hero: {
    title: 'Step Into 1970s Japan',
    subtitle: 'Showa Retro Stay in Tokyo',
    description: 'Experience authentic Showa-era living in our traditional kominka house near Haneda Airport. Tatami rooms, vintage furnishings, and nostalgic atmosphere transport you to a Japanese film scene.',
    bookNow: 'Book Your Stay',
    viewGallery: 'View Gallery',
  },
  about: {
    title: 'Showa Experience',
    subtitle: 'Like stepping into a Japanese movie from the 1970s',
    description: 'Our traditional kominka house in Magome, Tokyo, preserves the warm atmosphere of 1970s Japan. Black rotary phones, chabudai low tables, retro posters, vintage appliances, and the gentle light filtering through shoji screens — every detail recreates the nostalgic Showa era. International guests often say it feels like "stepping into a Japanese film."',
    feature1Title: 'Entire House Rental',
    feature1Desc: 'Private whole-house stay for your group',
    feature2Title: 'Vintage Furnishings',
    feature2Desc: 'Authentic 1970s Japanese home atmosphere',
    feature3Title: 'Near Haneda Airport',
    feature3Desc: 'Easy access — 25 minutes by train',
    feature4Title: 'Traditional Tatami',
    feature4Desc: 'Authentic tatami rooms with shoji screens',
  },
  rooms: {
    title: 'Showa Experience',
    subtitle: 'Discover the charm of 1970s Japan',
    room1: 'Black Rotary Phone',
    room2: 'Chabudai Low Table',
    room3: 'Retro Posters',
    capacity: 'Maximum Capacity',
    guests: '8 Guests',
    amenities: 'Amenities',
    amenitiesList: 'Vintage appliances, Tatami rooms, Shoji screens, Full kitchen, Wi-Fi, Air conditioning, Heating, Washing machine, Bathroom, Towels, Toiletries',
  },
  gallery: {
    title: 'Gallery',
    subtitle: 'Moments from the Showa era',
  },
  reservation: {
    title: 'Reservation',
    subtitle: 'Book your Showa retro experience',
    name: 'Full Name',
    email: 'Email Address',
    phone: 'Phone Number',
    checkin: 'Check-in',
    checkout: 'Check-out',
    guests: 'Number of Guests',
    purpose: 'Purpose of Stay',
    purposePlaceholder: 'Select purpose',
    purposeOptions: {
      tourism: 'Tourism / Sightseeing',
      workation: 'Workation / Remote Work',
      longStay: 'Long Stay (7+ nights)',
      business: 'Business Trip',
      other: 'Other',
    },
    message: 'Special Requests',
    submit: 'Submit Reservation',
    submitting: 'Submitting...',
    success: 'Your reservation request has been received. We will contact you shortly.',
    error: 'Failed to submit. Please try again.',
    bookingPlatforms: 'You can also book via these platforms',
    bookOnAirbnb: 'Check availability & book on Airbnb',
    bookOnJalan: 'Check availability & book on Jalan',
    orDirectBooking: 'or contact us directly',
    directBookingTitle: 'Direct Booking Benefits',
    directBookingBenefit1: 'Best price guarantee — no platform fees',
    directBookingBenefit2: 'Flexible check-in/out times',
    directBookingBenefit3: 'Direct communication with host',
    directBookingBenefit4: 'Special long-stay discounts available',
    required: 'Required',
    guestsPlaceholder: '― Please select ―',
    guestSingular: 'Guest',
    guestPlural: 'Guests',
    messagePlaceholder: 'Any special requests or questions? Feel free to ask. (max 500 characters)',
    confirmNote: '※ We will contact you after confirming your reservation request.',
  },
  contact: {
    title: 'Contact',
    subtitle: 'Feel free to reach out with any questions or inquiries',
    name: 'Full Name',
    email: 'Email Address',
    subject: 'Subject',
    message: 'Message',
    submit: 'Send',
    submitting: 'Sending...',
    success: 'Your message has been received. We will contact you shortly.',
    error: 'Failed to send. Please try again.',
    address: 'Address',
    addressDetail: '〒143-0022 1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    access: 'Access',
    accessDetail: '8 minutes walk from Magome Station (Toei Asakusa Line)',
    faqBannerTitle: 'Before submitting, please check our FAQ',
    faqBannerDesc: "We've already answered many common questions about pricing, procedures, and management.",
    faqBannerBtn: 'View FAQ',
    accessInfoTitle: 'Access Information',
    sendMessageTitle: 'Send a Message',
    inquiryType: 'Inquiry Type',
    inquiryTypePlaceholder: 'Select inquiry type',
    inquiryOptions: {
      minpaku: 'Minpaku Registration / Permit Application',
      ryokan: 'Ryokan License Acquisition',
      management: 'Property Management / Operations',
      pricing: 'Pricing / Plans',
      marketing: 'Airbnb Listing / Marketing',
      revenue: 'Revenue Simulation',
      other: 'Other',
    },
    messagePlaceholder: 'Please describe your inquiry (up to 500 characters)',
    detailLabel: 'Consultation Details',
    detailPlaceholder: 'Please describe your property location, current situation, and any requests (max 500 characters)',
  },
  access: {
    label: 'Access',
    title: 'Access & Map',
    subtitle: 'Located in the quiet residential area of Higashi-Magome, Ota-ku, Tokyo',
    addressLabel: 'Address',
    addressLine1: '1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    addressLine2: '〒143-0022 1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    trainLabel: 'By Train',
    trainLine1: '2 min walk from Magome Station (Toei Asakusa Line)',
    trainLine2: '',
    busLabel: 'By Bus',
    busLine1: '2 min walk from "Magome Ekimae" bus stop (Toei Bus)',
    busLine2: '',
    parkingLabel: 'Parking',
    parkingLine1: 'Coin parking lots available nearby',
    parkingLine2: 'Please contact us if you plan to arrive by car',
    openMap: 'Open in Google Maps',
  },
  footer: {
    description: 'A Showa retro traditional kominka house in Magome, Ota-ku, Tokyo. Experience the nostalgic atmosphere of 1970s Japan.',
    quickLinks: 'Quick Links',
    followUs: 'Follow Us',
    rights: 'All rights reserved.',
    napTitle: 'Yokota Tax & Accounting Office',
    napAddress: '1-12-12 Higashi-Magome, Ota City, Tokyo',
    napAddressJa: '東京都大田区東馬込1-12-12',
    napPhone: 'Phone: Please contact us',
    napServiceArea: 'Service Area: Ota City & Greater Tokyo',
    napAccess: 'Toei Asakusa Line — Magome Station',
  },
  stickyButton: {
    title: 'Free 30-Min',
    subtitle: 'Consultation',
  },
  ownersBanner: {
    subtitle: 'For property owners considering Airbnb in Tokyo',
    linkText: 'Learn about our support services for property owners →',
  },
  airbnbLead: {
    title: 'Thinking of Starting Airbnb in Tokyo?',
    description: 'We provide end-to-end support — from minpaku registration and ryokan license acquisition to full property management. Based in Ota City with real operational experience.',
    ctaButton: 'Get Free Consultation',
    badge1: 'No obligation consultation',
    badge2: 'Real operational experience',
    badge3: 'Full support from licensing to management',
  },
  trust: {
    badge: 'Why Choose Us',
    title: 'Trusted by Tokyo Property Owners',
    subtitle: 'We combine real operational experience with comprehensive support to help you succeed.',
    point1Title: 'Real Airbnb Experience',
    point1Description: 'We actively operate our own traditional lodging in Ota City. Our advice is based on firsthand experience, not theory.',
    point2Title: 'Full Licensing Support',
    point2Description: 'From minpaku registration to ryokan license acquisition — we handle all paperwork and authority communication.',
    point3Title: 'Revenue Optimization',
    point3Description: 'Data-driven pricing strategies based on real Tokyo market data. Average 30%+ revenue increase for our clients.',
    point4Title: '24/7 Guest Support',
    point4Description: 'Round-the-clock multilingual guest communication so you can focus on earning, not managing.',
    point5Title: 'Transparent Reporting',
    point5Description: 'Monthly revenue reports and clear fee structures. No hidden costs, no surprises.',
    ctaButton: 'Explore Our Services',
  },
  howItWorks: {
    title: 'How It Works',
    subtitle: 'A simple, transparent process from consultation to successful launch',
    step1Number: '01',
    step1Title: 'Free Consultation',
    step1Desc: 'Share your property details and goals. We provide honest advice on licensing, revenue potential, and next steps.',
    step2Number: '02',
    step2Title: 'Property Assessment',
    step2Desc: "We evaluate your property's suitability, identify requirements, and create a customized action plan.",
    step3Number: '03',
    step3Title: 'Launch & Support',
    step3Desc: 'From license application to guest management, we handle everything so you can focus on earning.',
    ctaButton: 'Book Your Free Consultation',
    ctaNote: '30 minutes • No obligation • Clear roadmap',
  },
  urgency: {
    title: 'Thinking of Starting Airbnb in Tokyo?',
    description: 'Licensing rules are complex and mistakes can delay your launch. Get clear, practical advice before making decisions.',
    ctaButton: 'Book Free Consultation',
    note: '30-minute consultation • No obligation • Real experience',
  },
  trustRisk: {
    title: 'No Pressure Consultation',
    description: 'We provide practical advice based on real experience. Even if you decide not to proceed, you will receive a clear roadmap.',
    badge1Title: 'No Obligation',
    badge1Desc: 'Free advice with zero pressure',
    badge2Title: 'Real Experience',
    badge2Desc: 'We operate our own property',
    badge3Title: 'Clear Roadmap',
    badge3Desc: 'Actionable guidance you can use',
    whatYouGetTitle: "What You'll Get From Our Consultation",
    item1: "Honest assessment of your property's potential",
    item2: 'Clear explanation of licensing requirements and timeline',
    item3: 'Realistic revenue projections based on your location',
    item4: 'Step-by-step roadmap you can follow independently',
    ctaButton: 'Schedule Your Free Consultation',
    ctaNote: 'Available Monday–Friday, 9:00–18:00 JST',
  },
  faq: {
    title: 'Frequently Asked Questions',
    subtitle: 'Common questions about starting and operating Airbnb and Minpaku businesses in Tokyo',
    ctaText: "Have more questions? We're here to help.",
    ctaButton: 'Book a Free Consultation',
    q1: 'How to start Airbnb in Tokyo?',
    a1: 'Starting an Airbnb in Tokyo requires obtaining proper licensing. You have two main options: Minpaku (residential lodging) registration or Ryokan (simple lodging) license. Minpaku allows up to 180 days of operation per year and requires registration with local authorities. Ryokan license allows year-round operation but requires meeting stricter facility standards and fire safety regulations. We recommend consulting with professionals to determine which option suits your property and business goals.',
    q2: 'What is the difference between Minpaku and Ryokan license?',
    a2: 'Minpaku (民泊) is a residential lodging registration that allows property owners to rent their homes for up to 180 days per year. It has simpler requirements but operational limitations. Ryokan (簡易宿所) is a simple lodging business license that permits year-round operation without day limits. However, it requires meeting stricter facility standards, fire safety equipment, and regular inspections.',
    q3: 'Can foreigners start Airbnb in Japan?',
    a3: 'Yes, foreigners can start Airbnb businesses in Japan, but there are important requirements. You must have proper residency status that allows business activities in Japan. Property ownership or a valid lease agreement is required, and you must designate a management representative who resides in Japan and can respond to issues within 30 minutes.',
    q4: 'How long does Minpaku registration take in Tokyo?',
    a4: 'Minpaku registration in Tokyo typically takes 2–4 months from initial preparation to approval. The timeline includes: property assessment and preparation (2–3 weeks), document preparation and fire safety inspection (2–4 weeks), submission to local government (1–2 weeks processing), and final approval and registration (1–2 weeks).',
    q5: 'How much does it cost to get started?',
    a5: "Costs vary depending on the scope of services and your property's condition. We offer plans that include application support, document preparation, and on-site assessment. For property management services, we use a performance-based fee structure — a percentage of revenue — so you can get started with minimal upfront costs.",
    q6: 'What can you handle if I find self-management difficult?',
    a6: 'We can handle everything — reservation management, guest communication, cleaning coordination, key handover, issue resolution, and monthly revenue reporting. Property owners can essentially run a hands-free Airbnb operation.',
    q7: 'Can I run Airbnb in a condominium?',
    a7: "Running Airbnb in a condominium is possible as long as it is not prohibited by the building's management rules. You first need to check the management regulations to confirm there are no clauses banning lodging or short-term rental activities.",
    q8: "I'm worried about complaints from neighbors. How do you handle that?",
    a8: 'We set clear house rules for guests (noise, garbage disposal, use of common areas, etc.) and explain them carefully at check-in to prevent issues before they arise. If a complaint does occur, we have a 24-hour response system to quickly assess and address the situation.',
    q9: 'How much revenue can I expect?',
    a9: 'Revenue varies significantly depending on the property\'s location, size, amenities, and occupancy rate. In popular Tokyo areas, 1LDK to 2LDK properties can generate monthly revenues of ¥200,000–¥500,000 in some cases. We offer a free revenue simulation based on our past operational data.',
    q10: 'Is it okay to just consult? Will I be pressured to sign a contract?',
    a10: 'Absolutely — consultations alone are very welcome. We never pressure you into signing a contract on the spot. We hope you will take your time and make a decision at your own pace.',
  },
  seo: {
    home: {
      title: 'Showa Retro House Tokyo | Vintage Japanese Home Stay near Haneda Airport',
      description: 'Experience authentic 1970s Showa-era Japan in our traditional kominka house near Haneda Airport. Tatami rooms, vintage furnishings, and nostalgic atmosphere. Whole house rental in Magome, Tokyo.',
      keywords: 'Showa Retro House Tokyo, Vintage Japanese Home Stay, Traditional Tatami House near Haneda, 1970s Japan Experience, Kominka Tokyo, Japanese Old House, Haneda Airport Accommodation',
    },
    management: {
      title: 'Airbnb Management Service Tokyo | Full-Service Short-Term Rental',
      description: 'Professional Airbnb management in Tokyo. Guest communication, dynamic pricing, cleaning coordination, and monthly reporting. Full-service short-term rental management for Ota City and greater Tokyo.',
      keywords: 'Airbnb management Tokyo, short-term rental management, Ota City property management, guest communication Tokyo',
    },
    support: {
      title: 'Tokyo Minpaku & Ryokan License Support | Lodging Business Launch',
      description: 'Expert minpaku registration and ryokan license application support in Tokyo. Hands-on guidance from active hosts in Ota City — from paperwork to health department inspections and revenue launch.',
      keywords: 'minpaku registration Tokyo, ryokan license application Tokyo, Tokyo Airbnb support, Ota City short-term rental',
    },
    forOwners: {
      title: 'Tokyo Airbnb Management & Minpaku License Support for Property Owners',
      description: 'End-to-end Airbnb management and minpaku license support for Tokyo property owners. From licensing to daily operations and cleaning — complete support by experienced operators. Free consultation.',
      keywords: 'Tokyo Airbnb property owners, minpaku license support, property management Tokyo, Airbnb management Ota City',
    },
    pricing: {
      title: 'Airbnb Management Pricing Tokyo | Transparent Plans for Property Owners',
      description: 'Clear, transparent pricing for Airbnb management and minpaku support in Tokyo. Launch support, full setup, management service, and cleaning packages. No hidden fees.',
      keywords: 'Airbnb management pricing Tokyo, minpaku support cost, short-term rental plans Tokyo, management fee Tokyo',
    },
    minpakuRegistration: {
      title: 'Minpaku Registration Tokyo | Step-by-Step Ryokan License Guide',
      description: 'Complete guide to minpaku registration in Tokyo. Full ryokan license application process, required documents, timeline, and common mistakes — based on real Ota City operational experience.',
      keywords: 'minpaku registration Tokyo, ryokan license application Tokyo, Tokyo Airbnb support, Ota City short-term rental',
    },
    guide: {
      title: 'Tokyo Minpaku Startup Guide 2026 | Licensing, Revenue & Management',
      description: 'Complete guide to starting your Airbnb business in Tokyo. Minpaku vs Ryokan licenses, step-by-step licensing, timeline, common mistakes, revenue estimation, and when to use management services.',
      keywords: 'Tokyo Minpaku guide, Airbnb Tokyo startup, Minpaku license, Ryokan license, Tokyo short-term rental, Airbnb licensing Tokyo, Minpaku registration',
    },
    caseStudy: {
      title: 'Ota City Minpaku Launch Case Study | Tokyo Airbnb Success Story',
      description: 'Real case study: Ota City property owner launched Airbnb in 3.5 months with Ryokan license, achieving ¥180,000+/month revenue and 78% occupancy. See how Tokyo minpaku support works in practice.',
      keywords: 'Ota City minpaku, Tokyo Airbnb case study, ryokan license Tokyo, Airbnb management Tokyo',
    },
    adsLanding: {
      title: 'Launch Your Legal Airbnb Business in Tokyo | Minpaku & Ryokan License Support',
      description: 'Professional minpaku and ryokan license support in Tokyo. End-to-end Airbnb management from Ota City active hosts. Free 30-min consultation. Launch support from ¥300,000.',
      keywords: 'Tokyo Airbnb legal, minpaku license support, ryokan application Tokyo, Airbnb launch Ota City',
    },
    airbnbGuide: {
      title: 'Tokyo Airbnb Legal Guide | Minpaku & Ryokan License Complete Guide',
      description: 'Complete guide to legally starting Airbnb in Tokyo. Minpaku registration, ryokan license requirements, costs, timeline, and step-by-step process — based on real Ota City operational experience.',
      keywords: 'Airbnb Tokyo license, minpaku registration Tokyo, ryokan license Tokyo, Airbnb management Tokyo, Ota City short-term rental',
    },
  },
  schema: {
    management: {
      offerDescription: '15%–20% of monthly revenue',
      service1: 'Dynamic Pricing & Rate Optimization',
      service2: 'Guest Communication (Multilingual)',
      service3: 'Review Management',
      service4: 'Cleaning & Linen Coordination',
      service5: 'Monthly Revenue Report',
      service6: 'Tax Filing Support Program',
    },
  },
  managementContact: {
    title: 'Free Consultation Form',
    name: 'Full Name',
    nameRequired: 'Required',
    phone: 'Phone Number',
    email: 'Email Address',
    emailRequired: 'Required',
    propertyType: 'Property Type',
    propertyTypePlaceholder: 'Please select',
    propertyTypeOptions: {
      mansion1k: 'Apartment (Studio–1LDK)',
      mansion2ldk: 'Apartment (2LDK+)',
      house: 'Detached House',
      kominka: 'Traditional / Old House',
      taxConsult: 'Tax Consultation',
      other: 'Other',
    },
    consultContent: 'Consultation Details',
    consultContentRequired: 'Required',
    consultContentCounter: '{{count}}/500 chars',
    consultContentPlaceholder: 'Please describe your property location, current situation, and any requests (max 500 characters)',
    submit: 'Apply for Free Consultation',
    submitting: 'Sending...',
    success: 'Thank you for your inquiry. We will contact you within 2 business days.',
    error: 'Failed to send. Please try again.',
    beforeContact: 'Before You Contact Us',
    infoItems: [
      'First consultation is completely free',
      'Primarily serving the Tokyo area',
      'Reply within 2 business days',
      'Your personal information is strictly protected',
    ],
    recommendTitle: 'We Recommend Consulting If You…',
    recommendItems: [
      'Own a property but cannot manage it yourself',
      'Want to start a side-business with Minpaku',
      'Are not satisfied with current revenue',
      'Are looking for a cleaning service',
      'Are unsure how to use Airbnb',
    ],
    confirmNote: 'After confirming your inquiry, our staff will contact you.',
  },
  taxOffice: {
    badge: 'Tax & Accounting Office',
    sectionTitle: 'Yokota Tax & Accounting Office',
    sectionSubtitle: 'Minpaku & Airbnb Tax Support Specialist in Higashi-Magome, Ota City, Tokyo',
    businessName: '横田税務会計事務所',
    businessNameEn: 'Yokota Tax & Accounting Office',
    addressLabel: 'Location',
    addressJa: '東京都大田区東馬込1-12-12',
    addressEn: '1-12-12 Higashi-Magome, Ota City, Tokyo, Japan',
  },
  sns: {
    badge: 'SNS',
    title: 'Follow us on Instagram',
    subtitle: 'Experience the Showa retro atmosphere through our photos',
    copied: 'Copied',
    copy: 'Copy',
    instagram: {
      title: 'Instagram Feed',
      subtitle: 'Discover nostalgic 1970s Japan through our photos',
      follow: 'Follow on Instagram',
      viewMore: 'View more posts on Instagram →',
    },
  },
  privateDriver: {
    badge: 'Partner Service',
    title: 'Private Driver',
    titleEn: 'Private Driver Service',
    description: 'Our partner drivers provide professional transport — from airport transfers to sightseeing tours.',
    descriptionHighlight: 'English-speaking drivers available.',
    featureTitle: 'Why Choose Our Driver Service',
    features: [
      { title: 'English-Speaking Drivers', desc: 'English-speaking professional drivers for international guests.' },
      { title: 'Safe & Insured', desc: 'Fully insured professional drivers guarantee safe and comfortable travel.' },
      { title: '24/7 Availability', desc: 'Early morning flights or late-night arrivals — we are always ready with advance booking.' },
      { title: 'Large Luggage OK', desc: 'Large vehicles available for families. Multiple suitcases are no problem.' },
      { title: 'Custom Routes', desc: 'Special routes to Showa retro spots and photo shoot locations available on request.' },
    ],
    menuTitle: 'Service Menu',
    priceGuide: 'Price Guide',
    pricingTitle: 'Pricing Guide',
    pricingNote: 'All prices include tax. Estimates only — contact us for exact quotes.',
    discountBadge: 'Exclusive Discount',
    discountTitle: 'Guests Only',
    discountOff: '10% OFF',
    discountSuffix: 'Special Discount',
    discountNote: 'Mention your stay when booking to receive the discount.',
    discountBtn: 'Book Now',
    ctaBadge: 'Exclusive for KOMINKA Guests',
    ctaTitle: 'Special Rates for Guests',
    ctaDesc: 'KOMINKA guests enjoy exclusive discounts on our private driver service.',
    ctaBtn: 'Book a Driver',
    officialPartner: 'Official Partner',
    officialPartnerJa: '提携サービス',
    services: [
      {
        title: 'Airport Transfer',
        subtitle: '空港送迎',
        desc: 'Haneda / Narita airport pickup & drop-off. Meet & greet service available.',
        price: 'From ¥8,000',
      },
      {
        title: 'Tokyo City Tour',
        subtitle: '東京観光ドライブ',
        desc: 'Explore Showa-era neighborhoods, temples, and hidden gems with a local driver.',
        price: 'From ¥15,000 / 3h',
      },
      {
        title: 'Long Stay Support',
        subtitle: '長期滞在サポート',
        desc: 'Weekly or monthly driver service for shopping, day trips, and errands.',
        price: 'From ¥40,000 / week',
      },
      {
        title: 'Photo Location Drive',
        subtitle: '撮影ロケ送迎',
        desc: 'Transport to iconic Showa-era spots, retro shotengai, and film locations.',
        price: 'From ¥12,000 / 2h',
      },
    ],
    pricing: [
      {
        title: 'Airport Transfer',
        subtitle: '空港送迎',
        rows: [
          { label: 'Haneda Airport ⇔ Magome (one way)', price: '¥8,000+' },
          { label: 'Narita Airport ⇔ Magome (one way)', price: '¥14,000+' },
          { label: 'Late night / early morning surcharge (22:00–6:00)', price: '+¥2,000' },
          { label: 'Large luggage (3+ suitcases)', price: '+¥1,000' },
        ],
        note: '* Same price for up to 4 passengers',
      },
      {
        title: 'Tokyo City Tour',
        subtitle: '東京観光ツアー',
        rows: [
          { label: '3-hour course', price: '¥15,000+' },
          { label: '5-hour course', price: '¥22,000+' },
          { label: 'Full day (8 hours)', price: '¥35,000+' },
          { label: 'Showa Retro special route', price: '+¥3,000' },
        ],
        note: '* Guide fee & parking included',
      },
      {
        title: 'Photo Location Drive',
        subtitle: '撮影ロケ送迎',
        rows: [
          { label: '2-hour course', price: '¥12,000+' },
          { label: '4-hour course', price: '¥20,000+' },
          { label: 'Location guide option', price: '+¥2,000' },
          { label: 'Equipment / large luggage handling', price: '+¥1,500' },
        ],
        note: '* Route consultation available in advance',
      },
      {
        title: 'Long Stay Support',
        subtitle: '長期滞在サポート',
        rows: [
          { label: 'Once a week plan (4x/month)', price: '¥40,000+' },
          { label: 'Twice a week plan (8x/month)', price: '¥72,000+' },
          { label: 'Single use (3 hours)', price: '¥12,000+' },
          { label: 'Shopping / hospital transfer', price: '¥6,000+/trip' },
        ],
        note: '* 10% discount with monthly payment',
      },
    ],
  },
};

export default common;